module.exports = __webpack_public_path__ + "img/investment.a8177b44.svg";